module.exports = __webpack_public_path__ + "static/media/l1.f86ad12c.jpg";